import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "input",
    "display",
    "plusButton",
    "minusButton",
    "destroyInput",
  ];

  connect() {
    this.syncDestroy();
    this.updateButtonVisibility();
  }

  increment() {
    this.changeQuantity(1);
  }

  decrement() {
    this.changeQuantity(-1);
  }

  changeQuantity(delta) {
    const currentValue = parseInt(this.inputTarget.value) || 0;
    const newValue = Math.max(0, currentValue + delta);

    this.inputTarget.value = newValue;
    if (this.hasDisplayTarget) this.displayTarget.textContent = newValue;

    this.syncDestroy();
    this.updateButtonVisibility();
  }

  inputChanged() {
    this.syncDestroy();
  }

  syncDestroy() {
    const value = this.inputTarget.value.toString().trim();
    const isEmpty = value === "" || value === "0";
    this.destroyInputTarget.value = isEmpty ? "true" : "false";
  }

  updateButtonVisibility() {
    if (!this.hasMinusButtonTarget) return;

    this.minusButtonTarget.classList.toggle(
      "invisible",
      (parseInt(this.inputTarget.value) || 0) === 0
    );
  }
}
